
import { Component, Vue } from 'vue-property-decorator';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Top from '@/components/Top.vue';
import Bottom from '@/components/Bottom.vue';
import { Api } from '@/utils/request';
import TopBg from '@/components/TopBg.vue';
import date from '@/utils/date';
import MokYun from '@/components/MokYun.vue';
import Bar from '@/components/Bar.vue';
import ContentType from '@/interfaces/content-type';
import FileType from '../interfaces/file-type';
Vue.use(ElementUI);
@Component({
  components: {
    MokYun,
    Top,
    Bottom,
    TopBg,
    Bar,
  },
})
export default class Mokyun extends Vue {
  public menuList: any = [];
  public configInfo: any = [];
  public content: any = [];
  public type = 0;
  public id = 0;
  public style = false;

  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
    console.log(this.content.word);
  }
  scrollToTop() {
    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    if (scrollTop > 540) {
      this.style = true;
    }
    if (scrollTop < 540) {
      this.style = false;
    }
  }
  async created() {
    const res2: any = localStorage.getItem('menuList');
    this.menuList = JSON.parse(res2);
    const res: any = localStorage.getItem('config');
    this.configInfo = JSON.parse(res);
    this.type = Number(this.$route.query.type);
    this.id = Number(this.$route.query.id);
    if (this.type === ContentType.Download) {
      this.content = await Api.Download.getContent({
        id: Number(this.id),
      });
    } else if (this.type === ContentType.Company) {
      this.content = await Api.Company.getContent({
        id: Number(this.id),
      });
    } else {
      this.content = await Api.Article.getContent({
        id: Number(this.id),
      });
    }
    this.content.uploadTime = date(this.content.uploadTime).date;
    if (this.content.content) {
      this.content.content = this.content.content.replace(/%26nbsp;/g, ' ');
    }
  }

  download() {
    var word = JSON.parse(this.content.word);
    window.location.href = word[0].url + `?attname=${word[0].name}`;
    // if (this.content.wordType === FileType.Doc) {
    //   // window.open(this.content.word + `?attname=${this.content.title}.doc`);
    //   window.location.href = word[0].url + `?attname=${this.content.title}.doc`;
    // }
    // if (this.content.wordType === FileType.Docx) {
    //   // window.open(this.content.word + `?attname=${this.content.title}.docx`);
    //   window.location.href =
    //     word[0].url + `?attname=${this.content.title}.docx`;
    // }
    // if (this.content.wordType === FileType.Xslx) {
    //   // window.open(this.content.word + `?attname=${this.content.title}.xslx`);
    //   window.location.href =
    //     word[0].url + `?attname=${this.content.title}.xslx`;
    // }
  }
}
